let authSvc = new AuthenticationService();
let materialSvc = new MaterialService();
let saleSvc = new SaleDataService();
let favSvc = new FavoriteBookService();
let eBookSvc = new EBookService();
